<mat-accordion displayMode="flat">
  <mat-expansion-panel class="custom-panel">
    <mat-expansion-panel-header>
      <mat-panel-title>{{ title() }}</mat-panel-title>
    </mat-expansion-panel-header>
    
    <div class="content">
      <ng-content></ng-content>
    </div>
  </mat-expansion-panel>
</mat-accordion>